import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import { disableSwitcher } from "../../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import accountNameStandardised from "../../../../../utils/accountNamestandardised";

const InternalMultiApprovalTxnSuccess = () => {
  const [successPageData, setsuccessPageData] = useState([]);
  const [pendingTransactions, setPendingTransactions] = useState([]);

  const [approvedTransactions, setApprovedTransactions] = useState([]);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(disableSwitcher());
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedData"),
    );

    if (storedSelectedApproval) {
      const transactions =
        storedSelectedApproval?.selectedSendTransactions || [];

      const pending = transactions.filter(
        (transaction) => transaction.lifecycle_status === "pending",
      );
      const approved = transactions.filter(
        (transaction) => transaction.lifecycle_status === "approved",
      );
      setsuccessPageData(storedSelectedApproval?.selectedSendTransactions);
      setPendingTransactions(pending);
      setApprovedTransactions(approved);
    } else {
      setsuccessPageData([]);
    }
  }, []);

  const buttonRows = [
    [
      {
        btnText: "Approve more transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON,
        imgColor: "var(--positive-bg)",
        handleFunction: () =>
          navigate(
            "/internal_transaction_dashboard/internal_transaction_multi_approval",
          ),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/internal_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const TransactionList = ({ transactions, type }) => (
    <>
      {transactions?.map((txn, i) => (
        <InfoCard
          key={i}
          bgColor="var(--positive-card)"
          hoverable="white"
          onClick={() =>
            navigate(
              `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${txn?.txn_id}`,
            )
          }
          rows={[
            {
              leftTitle: accountNameStandardised(txn?.internal_account_name),
              leftSubTitle: "Account name",
              rightTitleTextColor: "var(--text-primary)",
              rightTextFontWeight: "semibold",
              hasRight: true,
              rightIcon: true,
              rightText: true,
              rightTitle: `INR ${FormatAmount({ price: txn?.amount })}`,
              rightSubTitle: "Amount",
              onClick: () =>
                navigate(
                  `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${txn?.txn_id}`,
                ),
            },
          ]}
        />
      ))}
    </>
  );

  const totalTransactions =
    approvedTransactions.length + pendingTransactions.length;

  let titleText = "";

  if (!approvedTransactions.length && pendingTransactions.length) {
    titleText =
      totalTransactions === 1
        ? "Transactions has been approved and pending further approval before distribution."
        : "Transactions have been approved and pending further approval before distribution.";
  } else {
    titleText =
      totalTransactions === 1
        ? "Transactions has been approved."
        : "Transactions have been approved.";
  }

  return (
    <>
      {/* Component implementation */}
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={titleText}
      >
        {!!(pendingTransactions.length && !approvedTransactions.length) && (
          <TabsWeapperSection title={`Pending - ${pendingTransactions.length}`}>
            <>
              {pendingTransactions?.map((txn, i) => (
                <InfoCard
                  key={i}
                  bgColor="var(--positive-card)"
                  hoverable="white"
                  onClick={() =>
                    navigate(
                      `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${txn?.txn_id}`,
                    )
                  }
                  rows={[
                    {
                      leftTitle: txn?.internal_account_name
                        ?.toLowerCase()
                        .split(" ")
                        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                        .join(" "),
                      leftSubTitle: "Account name",
                      rightTitleTextColor: "var(--text-primary)",
                      rightTextFontWeight: "semibold",
                      hasRight: true,
                      rightIcon: true,
                      rightText: true,
                      rightTitle: `INR ${FormatAmount({ price: txn?.amount })}`,
                      rightSubTitle: "Amount",
                      onClick: () =>
                        navigate(
                          `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${txn?.txn_id}`,
                        ),
                    },
                  ]}
                />
              ))}
            </>
          </TabsWeapperSection>
        )}

        {!!(approvedTransactions.length && !pendingTransactions.length) && (
          <TabsWeapperSection
            title={`Distribution created - ${approvedTransactions.length}`}
          >
            <>
              {successPageData?.map((txn, i) => (
                <InfoCard
                  key={i}
                  bgColor="var(--positive-card)"
                  hoverable="white"
                  onClick={() =>
                    navigate(
                      `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${txn?.txn_id}`,
                    )
                  }
                  rows={[
                    {
                      leftTitle: txn?.internal_account_name
                        ?.toLowerCase()
                        .split(" ")
                        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                        .join(" "),
                      leftSubTitle: "Account name",
                      rightTitleTextColor: "var(--text-primary)",
                      rightTextFontWeight: "semibold",
                      hasRight: true,
                      rightIcon: true,
                      rightText: true,
                      rightTitle: `INR ${FormatAmount({ price: txn?.amount })}`,
                      rightSubTitle: "Amount",
                      onClick: () =>
                        navigate(
                          `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${txn?.txn_id}`,
                        ),
                    },
                  ]}
                />
              ))}
            </>
          </TabsWeapperSection>
        )}

        {!!(approvedTransactions.length && pendingTransactions.length) && (
          <>
            <TabsWeapperSection
              title={`Distribution created - ${approvedTransactions.length}`}
            >
              <>
                <TransactionList
                  transactions={approvedTransactions}
                  type={"Approved"}
                />
              </>
            </TabsWeapperSection>
            <TabsWeapperSection
              title={`Pending - ${pendingTransactions.length}`}
            >
              <>
                <TransactionList
                  transactions={pendingTransactions}
                  type={"Pending"}
                />
              </>
            </TabsWeapperSection>
          </>
        )}
      </StatusContainer>
      {/* Component implementation */}
    </>
  );
};

export default InternalMultiApprovalTxnSuccess;
